import * as api from '../../../clients/incidents';

import {Action} from '@ngrx/store';

export const GET_ABARBEITER_MIT_ROLLEN_ZENTRALE_ADMIN = '[IncidentsModul] GetAbarbeiterMitRollenZentraleAdmin laden';
export const GET_ABARBEITER_MIT_ROLLEN_ZENTRALE_ADMIN_AUSFUEHREN = '[IncidentsModul] GetAbarbeiterMitRollenZentraleAdmin ausführen';
export const GET_ABARBEITER_MIT_ROLLEN_ZENTRALE_ADMIN_ERFOLGREICH = '[IncidentsModul] GetAbarbeiterMitRollenZentraleAdmin laden erfolgreich';
export const GET_ABARBEITER_MIT_ROLLEN_ZENTRALE_ADMIN_FEHLER = '[IncidentsModul] GetAbarbeiterMitRollenZentraleAdmin Ladefehler';
export const GET_ABARBEITER_MIT_ROLLEN_ZENTRALE_ADMIN_NICHT_AUSGEFUEHRT = '[IncidentsModul] GetAbarbeiterMitRollenZentraleAdmin nicht ausgeführt (evtl. Offline)';


export class GetAbarbeiterMitRollenZentraleAdminAction implements Action {
    readonly type = GET_ABARBEITER_MIT_ROLLEN_ZENTRALE_ADMIN;
        constructor(public optPayload: any = null) {}
    }
export class GetAbarbeiterMitRollenZentraleAdminAusfuehrenAction implements Action {
    readonly type = GET_ABARBEITER_MIT_ROLLEN_ZENTRALE_ADMIN_AUSFUEHREN;
        constructor(public optPayload: any = null) {}
    }
export class GetAbarbeiterMitRollenZentraleAdminErfolgreichAction implements Action {
    readonly type = GET_ABARBEITER_MIT_ROLLEN_ZENTRALE_ADMIN_ERFOLGREICH;
        constructor(public payload: api.AbteilungenUndRollenZentrale, public optPayload: any = null) {}
    }
export class GetAbarbeiterMitRollenZentraleAdminFehlerAction implements Action {
    readonly type = GET_ABARBEITER_MIT_ROLLEN_ZENTRALE_ADMIN_FEHLER;
        constructor(public payload: any, public optPayload: any = null) {}
    }
export class GetAbarbeiterMitRollenZentraleAdminNichtAusgefuehrtAction implements Action {
    readonly type = GET_ABARBEITER_MIT_ROLLEN_ZENTRALE_ADMIN_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type IncidentsQueryAbarbeiterMitRollenZentraleAdminActions =
    GetAbarbeiterMitRollenZentraleAdminAction
    | GetAbarbeiterMitRollenZentraleAdminAusfuehrenAction
    | GetAbarbeiterMitRollenZentraleAdminErfolgreichAction
    | GetAbarbeiterMitRollenZentraleAdminFehlerAction
    | GetAbarbeiterMitRollenZentraleAdminNichtAusgefuehrtAction
    ;
